import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const FEEDBACK_STATUS = ['pending', 'in_progress', 'completed', 'rejected'] as const;

export const FEEDBACK_COMPLETED_STATUS: (typeof FEEDBACK_STATUS)[number] = 'completed';

export const FEEDBACK_COMPLETION_LABEL = {
  completed: 'Completed',
  notComplete: 'Not Complete',
} as const;

export type FeedbackCompletion = keyof typeof FEEDBACK_COMPLETION_LABEL;

export const FEEDBACK_COMPLETION_TONE: Record<FeedbackCompletion, StatusColorTone> = {
  completed: 'success',
  notComplete: APPROVAL_STATUS_TONE.pending,
};

export const FEEDBACK_COMPLETE_FILTER = ['all', 'complete', 'not_complete'] as const;
export type FeedbackCompleteFilter = (typeof FEEDBACK_COMPLETE_FILTER)[number];

export const FEEDBACK_COMPLETE_FILTER_LABELS: Record<FeedbackCompleteFilter, string> = {
  all: 'All',
  complete: 'Complete',
  not_complete: 'Not Complete',
};

export const DEFAULT_FEEDBACK_COMPLETE_FILTER: FeedbackCompleteFilter = 'not_complete';

export const FEEDBACK_READ_FILTER = ['read', 'unread'] as const;
export type FeedbackReadFilter = (typeof FEEDBACK_READ_FILTER)[number];

export const FEEDBACK_READ_FILTER_LABELS: Record<FeedbackReadFilter, string> = {
  read: 'Read',
  unread: 'Unread',
};

export const FEEDBACK_FILTER_KEYS = {
  typeId: 'typeId',
  reportingToId: 'reportingToId',
  userId: 'userId',
  completeStatus: 'completeStatus',
  readStatus: 'readStatus',
} as const;

export const ADMIN_MESSAGE_MAX = 1000;

export const DEFAULT_PAGE_SIZE = 20;
